<template>
    <div class="welcome">
        <v-layout row wrap>
            <v-flex xs12>
                <v-img src="images/Kreis.png" class="intro-logo"></v-img>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs8 sm10 offset-xs2 offset-sm1 class="hidden-xs-only">
                <p style="width:100%;color:#009fdf;">
                    #vorausschauend&nbsp;&nbsp;&nbsp;#stolperfrei&nbsp;&nbsp;&nbsp;#in4minuten
                </p>
            </v-flex>
            <v-flex xs8 sm10 offset-xs2 offset-sm1 class="hidden-sm-and-up">
                <p style="width:100%;color:#009fdf;">
                    #vorausschauend<br>#stolperfrei<br>#in4minuten
                </p>
            </v-flex>
            <v-flex xs2 sm1>
                <div v-if="accepted" class="display-flex">
                    <div class="center-by-margin">
                        <router-link to="/fragen"><img class="ui-btn" src="icons/qa/ui/btnForward.svg" /></router-link>
                    </div>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        name: "Welcome",
        computed: {
            accepted(){
                return this.$store.getters['getDsAccepted'];
            }
        },
        components: {  }
    }
</script>

<style>
    .welcome {
        width: 100%;
        font-size: 32px;
        line-height: 1.5em;
    }
    .display-flex {
        display: flex;
        height: 100%;
    }
    .center-by-margin {
        margin: auto;
    }
    .ui-btn {
        width: 1.5em;
        height: 1.5em;
    }
    .intro-logo {
        width: 50%;
    }

</style>
